import ListBookingPaymentSourcesManager from '../../services/ListBookingPaymentSourcesManager';
import type { BookingPaymentDetails } from '../../types/api/v1/obt/pnr/payment';
import type { BookingPaymentSource } from '../../types/api/v2/obt/model/booking-payment-source';
import type { ListBookingPaymentSourcesResponse } from '../../types/api/v2/obt/model/list-booking-payment-sources-response';
import { PaymentSourceType } from '../../types/api/v2/obt/model/payment-source-type';
import { getPaymentSourceIdsForPaymentDetails } from './getPaymentSourceIdsForPaymentDetails';

export function getValidPaymentSourcesForPaymentSetup(
  bookingPaymentDetails: BookingPaymentDetails,
  listBookingPaymentSourcesResponse: ListBookingPaymentSourcesResponse,
): BookingPaymentSource[] {
  const allPaymentSourceIds = getPaymentSourceIdsForPaymentDetails(bookingPaymentDetails);
  const paymentSourcesManager = new ListBookingPaymentSourcesManager(listBookingPaymentSourcesResponse);
  const validPaymentSources = allPaymentSourceIds
    .map((sourceId) => paymentSourcesManager.getBookingPaymentSourceById(sourceId))
    .filter((source): source is BookingPaymentSource => !!source)
    .filter((source) => {
      if (source.type !== PaymentSourceType.Card || !source.metadata || !('cardMetadata' in source.metadata)) {
        return false;
      }

      return true;
    });

  return validPaymentSources;
}
